import axios from 'axios'
import { BILLS_ENDPOINT } from '../../endpoints'

export async function addBills(body) {
  const response = await axios.post(`${BILLS_ENDPOINT}/`, body)
  return response?.data?.data
}
